import { API_BASE_URL } from '@synergy/config';
import { Dayjs } from 'dayjs';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { DefaultDeliveryOptionsDto } from '../models/dto/default-delivery-options-dto';
import { DefaultDeliveryOptionsRequest } from '../api/models/default-delivery-options-request';
import { DeliveryOptionsDto } from '../models/dto/delivery-options-dto';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { ShoppingCartDeliveryOptionsApi } from '../api/shopping-cart-delivery-options-api';
import { enqueueSnackbar } from './snackbar-actions';

const shoppingCartDeliveryOptionsApi = new ShoppingCartDeliveryOptionsApi(API_BASE_URL);

export const shoppingCartDeliveryOptionsReceived = createAction<DeliveryOptionsDto>(
    'shoppingCart/delivery-options-loaded'
);

export const defaultsChanged = createAction<DefaultDeliveryOptionsDto>('shoppingCart/default-delivery-options-changed');

export const getDeliveryOptions = () => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.getDeliveryOptions();
    if (response.success) {
        dispatch(shoppingCartDeliveryOptionsReceived(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setInvoiceAddress = (invoiceAddressId: number) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setInvoiceAddress(invoiceAddressId);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setDeliveryAddress = (deliveryAddressId: number) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setDeliveryAddress(deliveryAddressId);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setAvisoContact = (avisoContactId: number | null) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setAvisoContact(avisoContactId);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setDesiredDeliveryDate = (desiredDeliveryDate: Dayjs | null) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setDesiredDeliveryDate(desiredDeliveryDate?.toDate() || null);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setCostCentre = (costCentre: string) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setCostCentre(costCentre);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setOrderReference = (orderReference: string | null) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartDeliveryOptionsApi.setOrderReference(orderReference);
    if (!response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const changeDefaultSettings =
    (defaultDeliveryOptions: DefaultDeliveryOptionsRequest) => async (dispatch: AppDispatch) => {
        const response = await shoppingCartDeliveryOptionsApi.changeDefaultDeliveryOptions(defaultDeliveryOptions);
        if (response.success) {
            dispatch(defaultsChanged(response.result));
            dispatch(enqueueSnackbar(PoolSnackbar.success('app.cart.deliveryOptions.defaultsChanged')));
        } else {
            dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
        }
    };
